<template>
  <div :class="$style.Auth__Wrapper">
    <div :class="$style.Auth__Header">
      <p :class="$style.Auth__Header__title">
        {{ $t('common-verify-flow.authorize') }}
      </p>
      <p :class="$style.Auth__Header__desc">
        {{ $t('common-verify-flow.authorize_desc') }}
      </p>
    </div>
    <div :class="$style.Auth__QrWarpper" v-loading="qrInfo.isLoading">
      <div :class="$style.Auth__Qr" v-if="qrInfo.codeUrl">
        <qrcode :class="$style.Auth__Qr_code" :value="qrInfo.codeUrl" :options="{ width: 130, margin: 0 }" />
        <div :class="[$style['Auth__Qr_white-block'], $style['Auth__Qr_white-block-top']]" />
        <div :class="[$style['Auth__Qr_white-block'], $style['Auth__Qr_white-block-left']]" />
        <div :class="[$style['Auth__Qr_white-block'], $style['Auth__Qr_white-block-bottom']]" />
        <div :class="[$style['Auth__Qr_white-block'], $style['Auth__Qr_white-block-right']]" />
        <div v-show="!qrInfo.isLoading && qrInfo.state === QR_STATE_MAP.Normal" :class="$style.Auth__Qr_line" />
        <transition name="fade">
          <div v-show="qrInfo.state === QR_STATE_MAP.SUCCESS" :class="$style.Auth__Qr_State">
            {{ $t('common-verify-flow.scanned') }}
          </div>
        </transition>
      </div>
      <transition name="fade">
        <div :class="$style.Auth__QrCover" v-show="qrInfo.state === QR_STATE_MAP.Overdue">
          <span>
            {{ $t('common-verify-flow.refresh_desc') }}
          </span>
          <div :class="$style.Auth__QrCover__btn" @click="handleRefresh">
            {{ $t('common-verify-flow.refresh') }}
          </div>
        </div>
      </transition>
    </div>

    <div :class="$style.Auth__Install">
      <p>
        {{ $t('common-verify-flow.install_desc') }}
      </p>
      <div :class="$style.Auth__Install__group">
        <div :class="$style.Auth__Install__block" @click="handleApple">
          <IconApple :class="$style.Auth__Install__Icon_Apple" />
          <span>App Store</span>
        </div>
        <div :class="$style.Auth__Install__block" @click="handleGoogle">
          <img src="../img/ic_google.svg" />
          <span>Google Play</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, reactive } from 'vue'

import VueQrcode from '@chenfengyuan/vue-qrcode'
// import { useStore } from 'vue'
import messages from '../i18n'
import { axiosClient } from '~/common/js/axios'
import IconApple from '../img/ic_apple.svg?inline'
import { useStore } from '~/common/js/patch';
const QR_STATE_MAP = {
  Normal: 0,
  Overdue: 1,
  SUCCESS: 2,
}

export default {
  i18n: { messages },
  name: 'Authorize',
  components: {
    qrcode: VueQrcode,
    IconApple,
  },
  setup(_, context) {
    let timer = null
    const store = useStore()
    const qrInfo = reactive({
      isLoading: false,
      codeUrl: null,
      state: QR_STATE_MAP.Normal,
    })
    const handleContinue = () => {
      context.emit('next')
    }
    const handleCancel = () => {
      context.emit('cancel')
    }
    const getCode = (needLoading = false, isRetry = false) => {
      qrInfo.isLoading = needLoading
      axiosClient({
        method: 'GET',
        url: '/gw-api/user-center/front/risk/kyc/code/get',
      })
        .then((resp) => {
          if (resp?.success) {
            const { code = null, status = 'init' } = resp?.data
            if (status === 'scanned') {
              // 扫描成功
              handleSuccess()
            } else if (!qrInfo.codeUrl || isRetry) {
              // 第一次为codeUrl赋值
              qrInfo.state = QR_STATE_MAP.Normal
              qrInfo.codeUrl = code
            } else if (qrInfo.codeUrl !== code) {
              // 老的codeUrl过期 新的codeUrl 为 code
              qrInfo.state = QR_STATE_MAP.Overdue
              qrInfo.codeUrl = code
            } else {
              // 没有变化，则什么都不做
            }
          }
        })
        .finally(() => {
          qrInfo.isLoading = false
        })
    }

    const handleSuccess = () => {
      qrInfo.state = QR_STATE_MAP.SUCCESS
      if (store.state.newVerifyKycFlow.callback) {
        // 延迟回调
        setTimeout(() => {
          store.state.newVerifyKycFlow.callback()
          handleCancel()
        }, 2000)
      } else {
        handleCancel()
      }
    }
    const handleRefresh = () => {
      getCode(true, true)
    }
    const handleApple = () => {
      window.open('https://itunes.apple.com/app/id1396382871', '_blank')
    }
    const handleGoogle = () => {
      window.open('https://play.google.com/store/apps/details?id=com.bitmart.bitmarket', '_blank')
    }

    const init = () => {
      clearInterval(timer)
      getCode(true)
      timer = setInterval(getCode, 5000)
    }
    onMounted(() => {
      init()
    })
    onBeforeUnmount(() => {
      clearInterval(timer)
    })
    return {
      handleContinue,
      qrInfo,
      QR_STATE_MAP,
      handleRefresh,
      handleApple,
      handleGoogle,
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="less">
.day-mode {
  --comp-verify-flow-dialog-authorize-color-text: #1a1b1f;
  --comp-verify-flow-dialog-authorize-color-text-400: #6a7c81;
  --comp-verify-flow-dialog-authorize-color-text-300: #9cb3ba;
  --comp-verify-flow-dialog-authorize-color-text-reverse: #ffffff;

  --comp-verify-flow-dialog-authorize-color-bg: #fff;
  --comp-verify-flow-dialog-authorize-color-bg-400: #fafafa;
  --comp-verify-flow-dialog-authorize-color-bg-reverse: #383d4d;
}

.night-mode {
  --comp-verify-flow-dialog-authorize-color-text: #ffffff;
  --comp-verify-flow-dialog-authorize-color-text-400: #6a7c81;
  --comp-verify-flow-dialog-authorize-color-text-300: #9cb3ba;
  --comp-verify-flow-dialog-authorize-color-text-reverse: #1a1b1f;

  --comp-verify-flow-dialog-authorize-color-bg: #2a2d37;
  --comp-verify-flow-dialog-authorize-color-bg-400: #383d4d;
  --comp-verify-flow-dialog-authorize-color-bg-reverse: #fafafa;
}
</style>
<style lang="less" module>
@import '~/common/css/element-base-type.less';

@keyframes qrcode {
  0% {
    top: 0;
  }
  50% {
    top: 100%;
  }
  100% {
    top: 0;
  }
}
.Auth {
  &__Wrapper {
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      padding: 0 1em;
    }
  }
  &__Header {
    color: var(--comp-verify-flow-dialog-authorize-color-text, #1a1b1f);
    &__title {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
    }
    &__desc {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
    }
  }

  &__QrWarpper {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 1em;
    width: 100%;
    padding: 32px 0;
    background: var(--comp-verify-flow-dialog-authorize-color-bg-400, #fafafa);
    border-radius: 0.2em;
    min-height: 150px;
  }
  &__QrCover {
    position: absolute;
    top: 0;
    left: 0;
    background: #2b2e36de;
    background: var(--comp-verify-flow-dialog-authorize-color-bg-400, #fafafa);

    border-radius: 0.2em;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &__btn {
      width: 80%;
      max-width: 400px;
      height: 44px;
      text-align: center;
      color: var(--comp-verify-flow-dialog-authorize-color-text, #fff);
      margin-top: 16px;
      font-weight: 600;
      font-size: 14px;
      line-height: 44px;
      background: @blue-base;
      border-radius: 4px;
      cursor: pointer;
    }
    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--comp-verify-flow-dialog-authorize-color-text, #fff);
    }
  }
  &__Qr {
    position: relative;
    height: 150px;
    &_code {
      padding: 7px;
      border: 3px solid @blue-base;
      background-color: var(--comp-verify-flow-dialog-authorize-color-bg, #fff);
    }
    &_white-block {
      width: 80%;
      height: 3px;
      background-color: var(--comp-verify-flow-dialog-authorize-color-bg, #fff);
      position: absolute;
      &-top {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &-left {
        left: 0;
        top: 50%;
        width: 3px;
        height: 80%;
        transform: translateY(-50%);
      }
      &-bottom {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &-right {
        right: 0;
        top: 50%;
        width: 3px;
        height: 80%;
        transform: translateY(-50%);
      }
    }
    &_line {
      position: absolute;
      width: 120%;
      height: 2px;
      top: 50px;
      background-image: linear-gradient(to right, rgba(19, 194, 194, 0), rgba(19, 194, 194, 1), rgba(19, 194, 194, 0));
      left: 50%;
      transform: translateX(-50%);
      animation: qrcode 3s linear 0s infinite;
    }
    &_State {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--comp-verify-flow-dialog-authorize-color-bg-reverse, #383d4d);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--comp-verify-flow-dialog-authorize-color-text-reverse, #fff);
      font-size: 16px;
    }
  }
  &__Install {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    p {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--comp-verify-flow-dialog-authorize-color-text-300, #9cb3ba);
      text-align: center;
    }
    &__group {
      display: flex;
      margin: auto;
    }
    &__block {
      cursor: pointer;
      margin: 8px;
      height: 44px;
      background: var(--comp-verify-flow-dialog-authorize-color-bg-400, #fafafa);
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 8px 30px 8px 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: var(--comp-verify-flow-dialog-authorize-color-text, #1a1b1f);
      box-sizing: border-box;
      gap: 20px;
      img {
        height: 26px;
      }
    }

    &__Icon_Apple {
      path {
        fill: var(--comp-verify-flow-dialog-authorize-color-text, #1a1b1f);
      }
    }
  }
}
</style>
